import React, { Component } from 'react';
import './price.scss';
import ApiServices from '../../services/apiServices';
import withRouter from '../../services/withRouter';
import { connect } from 'react-redux';
import { showLoader, hideLoader } from '../../action/application';
import CryptoJS from 'crypto-js';

class Price extends Component {
  userInfo = {};

  constructor(props) {
    super(props);
    this.state = {
      planList: [],
      activeCurrency: 'INR',
      allowUSD: false
    };
  }

  componentDidMount() {
    this.props.dispatch(showLoader());
    this.readUserInfo();
    this.getPlans();
  }

  readUserInfo() {
    try {
      const encrypted = localStorage.getItem('userKey');
      if (!encrypted) {
        this.userInfo = {};
        return;
      }
      const bytes = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_SECERET_KEY);
      const user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      this.userInfo = user || {};
    } catch (error) {
      this.userInfo = {};
    }
  }

  getPlans() {
    ApiServices.callGetAPI('membership/available')
      .then((result) => {
        if (result?.data?.valid && Array.isArray(result.data.data)) {
          const normalizedPlans = result.data.data.map((plan) => {
            const choices = (plan.membershipchoices || []).filter((choice) => choice.membership_id !== 'SP1');
            return {
              ...plan,
              membershipchoices: choices,
              selectedIndex: 0,
              selected_id: choices[0]?.membership_id || ''
            };
          });
          this.setState({
            planList: normalizedPlans,
            allowUSD: normalizedPlans.some((plan) => Number(plan.showusd) === 1)
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.props.dispatch(hideLoader());
      });
  }

  getPriceValue(choice, currency) {
    if (currency === 'USD') {
      return {
        actual: Number(choice.usd_actual_amount || 0),
        offer: Number(choice.usd_offer_amount || 0),
        hasOffer: Boolean(choice.usd_show_offer)
      };
    }

    return {
      actual: Number(choice.inr_actual_amount || 0),
      offer: Number(choice.inr_offer_amount || 0),
      hasOffer: Boolean(choice.inr_show_offer)
    };
  }

  formatAmount(value, currency) {
    if (!Number.isFinite(value)) return '-';
    if (currency === 'USD') return `$${value}`;
    return `INR ${value}`;
  }

  selectChoice = (planIndex, choiceIndex, membershipId) => {
    this.setState((prev) => {
      const planList = [...prev.planList];
      if (!planList[planIndex]) return { planList };
      planList[planIndex] = {
        ...planList[planIndex],
        selectedIndex: choiceIndex,
        selected_id: membershipId
      };
      return { planList };
    });
  };

  subscribe = (planIndex, choiceIndex, membershipId) => {
    this.selectChoice(planIndex, choiceIndex, membershipId);

    const headers = ApiServices.getHeader();
    if (!headers.headers.authorization) {
      this.props.navigate('/login');
      return;
    }

    const orderInfo = {
      membershipid: membershipId,
      currency: this.state.activeCurrency,
      name: this.userInfo.displayName || this.userInfo.displayname || '',
      email: this.userInfo.email || '',
      contact: this.userInfo.phoneNumber || ''
    };

    this.createOrder(orderInfo);
  };

  createOrder(orderData) {
    const headers = ApiServices.getHeader();
    if (!headers.headers.authorization) return;

    ApiServices.callPostAPI('membership/order', orderData)
      .then((result) => {
        if (result.status && result.data.valid) {
          if (result.data.data.amount > 0) {
            this.initPay({
              id: result.data.data.id,
              amount: result.data.data.amount,
              order_id: result.data.data.refId,
              currency: result.data.data.currency
            });
          } else {
            const paymentResult = {
              status: 'Success',
              paymentId: result.data.data.id,
              orderId: result.data.data.refId,
              signature: '3bb9dcbb089f0d4f5a790c0877a97009bd9b2d4e405318ec60b93d39c7c3c371',
              errorcode: 0,
              errortext: 'Success'
            };
            this.updateOrder(paymentResult);
          }
        }
      })
      .catch((error) => {
        this.props.navigate(this.props.url);
        console.log(error);
      });
  }

  updateOrder(paymentInfo) {
    ApiServices.callPutAPI('membership/order', paymentInfo)
      .then((result) => {
        if (result.status && result.data.valid) {
          window.history.back();
          this.props.navigate(this.props.PreviousUrl);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  initPay(order) {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: order.amount,
      order_id: order.order_id,
      currency: order.currency,
      name: process.env.REACT_APP_APP_NAME,
      description: 'Enjoy watching Movies on Shortflix',
      image: 'https://www.shortflixindia.com/assets/logo.png',
      handler: (response) => {
        const paymentResult = {
          status: response ? 'Success' : 'Failed',
          paymentId: response.razorpay_payment_id,
          orderId: response.razorpay_order_id,
          signature: response.razorpay_signature,
          errorcode: response ? 0 : 1,
          errortext: response ? 'Success' : 'Failed'
        };
        this.updateOrder(paymentResult);
      },
      prefill: {
        name: this.userInfo.displayName || this.userInfo.displayname || '',
        email: this.userInfo.email || '',
        contact: this.userInfo.phoneNumber || ''
      }
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  }

  swichCurrency = (event) => {
    this.setState({ activeCurrency: event.target.checked ? 'USD' : 'INR' });
  };

  getFeatures(text) {
    if (!text || typeof text !== 'string') return [];
    return text
      .split('-')
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
  }

  renderChoice(planIndex, choice, choiceIndex) {
    const { activeCurrency } = this.state;
    const { actual, offer, hasOffer } = this.getPriceValue(choice, activeCurrency);
    const payable = hasOffer && offer > 0 ? offer : actual;

    if (!payable) return null;

    return (
      <div
        key={choice.membership_id || `${planIndex}-${choiceIndex}`}
        className={`pricingTable-firstTable_table__pricing ${
          this.state.planList[planIndex]?.selectedIndex === choiceIndex ? 'active' : ''
        }`}
        onClick={() => this.selectChoice(planIndex, choiceIndex, choice.membership_id)}
      >
        <div className="choice-title">{choice.membership_display_name || 'Plan'}</div>
        {hasOffer && offer > 0 && offer < actual ? (
          <>
            <del>{this.formatAmount(actual, activeCurrency)}</del>
            <span>{this.formatAmount(offer, activeCurrency)}</span>
          </>
        ) : (
          <span>{this.formatAmount(actual, activeCurrency)}</span>
        )}

        <button
          className="pricingTable-firstTable_table__getstart"
          onClick={(e) => {
            e.stopPropagation();
            this.subscribe(planIndex, choiceIndex, choice.membership_id);
          }}
        >
          Subscribe
        </button>
      </div>
    );
  }

  render() {
    return (
      <div className="main-body price-body">
        {this.state.allowUSD && (
          <div className="toggle">
            <span className="roboto">INR</span>
            <input type="checkbox" id="switch" onChange={this.swichCurrency} />
            <label htmlFor="switch">Toggle</label>
            <span className="roboto">$ USD</span>
          </div>
        )}

        {this.state.planList.length > 0 ? (
          <ul className="pricingTable-firstTable">
            {this.state.planList.map((plan, i) => (
              <li key={plan.membershiptype || i} className="pricingTable-firstTable_table">
                <h1 className="pricingTable-firstTable_table__header">
                  {plan.membershiptype || 'Subscription Plan'}
                </h1>
                <p className="plan-description">
                  {'Subscribe now to unlock premium library access with an ad-free viewing experience.'}
                </p>

                {this.getFeatures(plan.membershiptext).length > 0 && (
                  <ul className="pricingTable-firstTable_table__options">
                    {this.getFeatures(plan.membershiptext).map((text, idx) => (
                      <li key={`${plan.membershiptype}-${idx}`}>{text}</li>
                    ))}
                  </ul>
                )}

                <div className="price flex justify-content-between">
                  {plan.membershipchoices.map((choice, j) => this.renderChoice(i, choice, j))}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <ul className="pricingTable-firstTable">
            <li className="pricingTable-firstTable_table">No plans available right now.</li>
          </ul>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.application.loading,
  PreviousUrl: state.application.PreviousUrl
});

export default withRouter(connect(mapStateToProps)(Price));
